import * as Canvas from "./Canvas";
import * as Create from "./Create";
import * as Form from "./Form";
import * as LinearAlgebra from "./LinearAlgebra";
import * as Num from "./Num";
import * as Op from "./Op";
import * as Pt from "./Pt";
import * as Space from "./Space";
import * as Color from "./Color";
import * as Util from "./Util";
import * as Dom from "./Dom";
import * as Svg from "./Svg";
import * as Typography from "./Typography";
import * as Physics from "./Physics";
import * as UI from "./UI";
import * as Play from "./Play";
import * as Image from "./Image";
import * as Types from "./Types";

declare global {
  // the browser bundle mounts the whole library on globalThis.Pts

  var Pts: Record<string, any>;
}

globalThis.Pts = {
  ...Canvas,
  ...Create,
  ...Form,
  ...LinearAlgebra,
  ...Num,
  ...Op,
  ...Pt,
  ...Space,
  ...Color,
  ...Util,
  ...Dom,
  ...Svg,
  ...Typography,
  ...Physics,
  ...UI,
  ...Play,
  ...Image,
};

// A function to switch scope for Pts library. eg, Pts.namespace( window );
globalThis.Pts.namespace = (scope: any) => {
  let lib = globalThis.Pts;
  for (let k in lib) {
    if (k != "namespace") {
      scope[k] = lib[k];
    }
  }
};

globalThis.Pts.quickStart = (id: string | Element, bg: string = "#9ab") => {
  if (!window) return;

  let s: any = globalThis;
  globalThis.Pts.namespace(s);

  // pick the rendering backend from the mount element: an <svg> element (or a
  // container holding one) gets an SVGSpace, anything else a CanvasSpace —
  // so a sketch can swap renderers by changing only its HTML
  // Preserve CanvasSpace's bare-ID shorthand for both rendering backends.
  const mount =
    typeof id === "string" && id[0] !== "#" && id[0] !== "." ? `#${id}` : id;
  const elem =
    typeof mount === "string" ? document.querySelector(mount) : mount;
  const isSVG =
    elem &&
    ((elem as Element).nodeName.toLowerCase() === "svg" ||
      !!(elem as Element).querySelector(":scope > svg"));

  s.space = isSVG
    ? new Svg.SVGSpace(mount).setup({ bgcolor: bg, resize: true })
    : new Canvas.CanvasSpace(mount).setup({
        bgcolor: bg,
        resize: true,
        retina: true,
      });
  s.form = s.space.getForm();

  return function (animate = null, start = null, action = null, resize = null) {
    s.space.add({
      start: start,
      animate: animate,
      resize: resize,
      action: action,
    });

    s.space.bindMouse().bindTouch().play();
  };
};
